module.exports = "images/france-tv.1e39b1ca.png";